import * as React from "react";
import NumberFormat from "react-number-format";

/**
 * This is a wrapper to show all numbers in the application with correct decimal and thousand separators
 */
interface IProps {
  value: number;
  decimals?: number;
}
export default class Number extends React.Component<IProps, {}> {
  public render() {
    if (isNaN(this.props.value)) {
      return <span>-</span>;
    }
    return <NumberFormat value={this.props.value} displayType="text" thousandSeparator=" " decimalSeparator="," decimalScale={this.props.decimals !== undefined ? this.props.decimals : 2} fixedDecimalScale={true} />;
  }
}
